import { includes } from 'lodash';
var BaseModel = /** @class */ (function () {
    function BaseModel(data) {
        this.id = data.id;
        this.name = data.name;
        this.hydrationStrategy = data.hydrationStrategy || 'hydrate';
    }
    BaseModel.prototype.modelMethodNotFound = function (name, obj) {
        var regex = /\w*Model/g;
        if (obj) {
            var modelMatch = regex.exec(obj.toString());
            var model = modelMatch.pop();
            if (model !== null) {
                console.warn("no " + name + " method available for " + model);
                return;
            }
        }
        console.error("method " + name + " not found on unknown model");
    };
    BaseModel.inDevelopmentEnvironment = function () {
        var _location = window.location;
        var origin = _location.origin;
        return includes(origin, 'localhost');
    };
    BaseModel.validType = function (data, expectedType) {
        if (typeof data !== expectedType) {
            if (BaseModel.inDevelopmentEnvironment()) {
                console.warn(data + " is not expected type " + expectedType);
            }
            return false;
        }
        return true;
    };
    BaseModel.prototype.convertBool = function (value) {
        if (typeof value === 'undefined') {
            return false;
        }
        if (value === 'false' || +value === 0) {
            return false;
        }
        return value;
    };
    BaseModel.prototype.convertInt = function (value, defaultValue) {
        if (defaultValue === void 0) { defaultValue = 0; }
        if (typeof value === 'undefined' || value === null) {
            return defaultValue;
        }
        if (value === '0') {
            return 0;
        }
        return +value;
    };
    BaseModel.prototype.hydrate = function (data) {
        this.modelMethodNotFound('hydrate', this);
        return {};
    };
    BaseModel.prototype.export = function (data) {
        this.modelMethodNotFound('export', this);
        return {};
    };
    BaseModel.prototype.useHydrator = function (data) {
        var functionName = this.hydrationStrategy;
        // @ts-ignore
        var hydrateFunction = this[functionName];
        return hydrateFunction(data);
    };
    BaseModel.prototype.printDebug = function () {
        var statement = '';
        for (var prop in this) {
            statement += prop + " - " + this[prop];
        }
        return statement;
    };
    return BaseModel;
}());
export default BaseModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/BaseModel.ts
// module id = z2Tw
// module chunks = 18